import { useCallback, useLayoutEffect, useRef } from "react";
import { useSetAtom } from "jotai";
import { displayedSourceFamily } from "../atoms/hangingProtocolAtoms";

/** Bind first-display readiness to the source, never to the selected-series menu. */
export function useDisplayedSource(slotId: string, studyUid: string, seriesUid: string | null) {
  const setSource = useSetAtom(displayedSourceFamily(slotId));
  const scope = `${studyUid}:${seriesUid}`;
  const live = useRef<string | null>(null);
  useLayoutEffect(() => {
    live.current = scope;
    setSource(null);
    return () => {
      live.current = null;
      setSource((previous) =>
        previous?.studyInstanceUid === studyUid && previous.seriesInstanceUid === seriesUid
          ? null
          : previous,
      );
    };
  }, [scope, studyUid, seriesUid, setSource]);
  return useCallback(
    (displayable: boolean) => {
      if (live.current !== scope) return false;
      setSource((previous) =>
        displayable && seriesUid
          ? previous?.studyInstanceUid === studyUid && previous.seriesInstanceUid === seriesUid
            ? previous
            : { studyInstanceUid: studyUid, seriesInstanceUid: seriesUid }
          : null,
      );
      return true;
    },
    [scope, seriesUid, studyUid, setSource],
  );
}
